













































































































// import UiCalendar from '../../Calendar/Calendar.vue'
import {MSGR_TG, MSGR_VK, MSGRS_LIST, STUD_FIELDS_VALS, MSGR_VB} from '@/constants'
import searchTableConfig from '@/components/Newsletters-stuff/CreateForm/searchTable'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'
import SelectField, {SelectFieldOptions} from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'
import {IFilters} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import Vue, {VueConstructor} from 'vue'
import {DateTime} from 'luxon'
import activeTable from '@/components/Ui/ActiveTable/ActiveTable.vue'
import UiFiltersAndActions from '@/components/Ui/FiltersAndActions/FiltersAndActions.vue'
import UiTable from '@/components/Ui/Table/Table.vue'
import {coerce} from '@/lib/array'
import _ from 'lodash'
import {Dictionary} from 'vuex'
import {TableOptions, TableColOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'
import Student from '@/models/Students/Student'
import Mailing from '@/models/mailing/mailing'

import Status from '@/components/Users/UserTable/cols/status.vue'
import Messengers from '@/components/Users/UserTable/cols/messengers.vue'
import DetailRow from '@/components/Users/UserTable/cols/detailRow.vue'
import IndexColumn from '@/components/Users/UserTable/cols/indexColumn.vue'

import rcptTableConfig from '@/activeTables/Newsletters/recipients-stuff'
import Radio from '@/components/Ui/Radio/Radio.vue'

import UserListFilters from '../ListFilters.vue'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    calendar: {months: DateTime[]},
    filters: {reset: () => void}
  }
}>).extend({
  name: 'SecondStep',
  components: {
    UserListFilters,
    activeTable,
    UiFiltersAndActions,
    UiTable,
    Radio,
  },
  props: {
    scope: {} as () => {mailingId: string},
    mailingId: String
  },
  data () {
    return {
      pageBaseUrl: '/newsletters-stuff/create',
      loading: false,
      forAllStitching: false,
      searchTableConfig,
      sendEvery: true,
      date: '',
      time: '',
      searchData: [],
      tableConfig: {
        cols: {
          last_name: {label: this.$t('labels.surname'), sortable: true},
          first_name: {label: this.$t('labels.name'), sortable: true},
          middle_name: {label: this.$t('labels.middle_name'), sortable: true},
          status: {label: this.$t('labels.cols.status'), component: Status, sortable: true},
          messengers: {label: this.$t('labels.cols.messengers'), component: Messengers}
        },
        detailRowComponent: DetailRow
      } as TableOptions,
      searchTablePagination: {
        pageSize: 20,
        currentPage: 1,
        totalItems: 43988
      },
      searchSort: {},
      defaultCols: ['last_name', 'first_name', 'middle_name', 'status', 'messengers'],
      checkedStuds: [] as Student[],
      showRecipsList: true,
      rcptTableConfig,
      hasFilters: false
    }
  },
  computed: {
    mailing (): Mailing | false {
      if (this.mailingId) {
        return this.$store.state.mailing.mailings[this.mailingId]
      } else {
        return false;
      }
    },
    checkedStudsKeys (): string[] {
      let keys = []
      for (const stud of this.checkedStuds) {
        keys.push(stud.id)
      }
      return keys;
    },
    shownColumns (): any {
      const cols: Dictionary<TableColOptions> = {
        _tableindex: {label: '№', component: IndexColumn}
      }
      for (const fieldName of this.defaultCols) {
        if (Object.keys(this.tableConfig.cols).indexOf(fieldName) !== -1) {
          cols[fieldName] = this.tableConfig.cols[fieldName]
        }
      }
      return cols
    },
    recipientsCounter (): number {
      if (this.mailing) {
        return this.mailing.getRcptNum();
      } else {
        return 0
      }
    },
    msgrNum (): number {
      if (this.mailing) {
        return this.mailing.getMsgrNum();
      } else {
        return 0
      }
    }
  },
  methods: {
    test (a: any) {
      console.log(a);
    },
    next () {
      if (this.recipientsCounter > 0) {
        this.$emit('next')
      } else {
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('newsletters.select_recipients'),
          type: 'warning'
        });
      }
    },
    prev () {
      this.$emit('prev')
    },
    async createMailing () {
      /* if (!this.scope.mailing_id) {
        // @ts-ignore
        let response = await this.$store.dispatch('mailing/create', {text: this.scope.text})
        // @ts-ignore
        this.mailingId = response.mailing_id
        this.scope.mailing_id = this.mailingId;
        await this.$store.dispatch('mailing/get', this.mailingId)
      } else {
        this.mailingId = this.scope.mailing_id;
      } */
    },
    onInput (value: any): void {
      this.$emit('input', {date: this.date, time: this.time})
    },
    async reloadMailing (): Promise<void> {
      if (this.mailingId) {
        await this.$store.dispatch('mailing/get', this.mailingId)
      }
    },
    onFiltersChanged: _.debounce(async function (query: any): Promise<void> {
      let emptyKeys: string[] = [];
      for (let key in query) {
        if (Array.isArray(query[key]) && !query[key].length) {
          emptyKeys.push(key)
          continue;
        }
        if (query[key] === '') {
          emptyKeys.push(key)
        }
      }

      for (let key of emptyKeys) {
        delete query[key]
      }
      // @ts-ignore
      let self = this as any;
      self.loading = true
      self.hasFilters = Object.keys(query).length ? true : false;
      try {
        if (self.mailingId) {
          await self.$store.dispatch('mailing/removeFilter', {mailing_id: self.mailingId, query: {filter: 'query'}})
          if (Object.keys(query).length) {
            await self.$store.dispatch('mailing/addFilter', {mailing_id: self.mailingId, query})
          }
          await self.reloadMailing();
          await self.reloadRcptsTable()
        }
      } catch (error) {
        console.error('LOG: error', error)
        self.$notify.error({
          // @ts-ignore
          title: this.$t('labels.error'),
          message: self.$t('newsletters.can_not_add_users')
        });
      }
      self.loading = false;
    }, 500),
    async onSearchStudChecked (studs: any) {
      try {
        this.checkedStuds = studs
        const lsn_ids = studs.map((stud: Student) => {
          return stud.id;
        });
        await this.$store.dispatch('mailing/removeFilter', {mailing_id: this.mailingId, query: {filter: 'id'}})
        if (lsn_ids.length) {
          await this.$store.dispatch('mailing/addIds', {mailing_id: this.mailingId, lsn_ids})
        }
        await this.reloadMailing()
        /* this.$notify({
          // @ts-ignore
          title: this.$t('labels.success'),
          // @ts-ignore
          message: this.$t('labels.user_added_success'),
          type: 'success'
        }); */
      } catch (error) {
        console.error('LOG: onSearchStudChecked -> error', error)
        this.$notify.error({
          // @ts-ignore
          title: this.$t('labels.error'),
          // @ts-ignore
          message: this.$t('newsletters.can_not_add_users')
        });
      }
    },
    toggleRecipsList () {
      this.showRecipsList = !this.showRecipsList
    },
    async clearRecipsList () {
      this.loading = true
      try {
        this.hasFilters = false;
        await this.$store.dispatch('mailing/removeFilter', {mailing_id: this.mailingId, query: {filter: 'id'}})
        await this.$store.dispatch('mailing/removeFilter', {mailing_id: this.mailingId, query: {filter: 'query'}})
        this.checkedStuds = []
        this.$refs.filters.reset();
        await this.reloadMailing();
        await this.reloadRcptsTable()
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.success'),
          // @ts-ignore
          message: this.$t('newsletters.users_list_cleared'),
          type: 'success'
        });
      } catch (error) {
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.error'),
          // @ts-ignore
          message: this.$t('newsletters.can_not_clear_recipients_list'),
          type: 'error'
        });
      }
      this.loading = false
    },
    onSearchReset () {
      this.searchData = []
    },
    async reloadRcptsTable () {
      // @ts-ignore
      await this.$refs.rcptsTable.loadList();
    },
    async sendToEvery () {
      if (this.sendEvery && this.mailingId) {
        await this.$store.dispatch('mailing/addFilter', {mailing_id: this.mailingId, query: {msgrs: MSGRS_LIST}})
        await this.reloadMailing()
        console.log('sendToEvery')
      }
    },
    async onSendEveryChange (val: boolean) {
      if (!val) {
        await this.$store.dispatch('mailing/removeFilter', {mailing_id: this.mailingId, query: {filter: 'query'}})
        await this.$store.dispatch('mailing/removeFilter', {mailing_id: this.mailingId, query: {filter: 'id'}})
        await this.reloadMailing()
      } else {
        await this.$store.dispatch('mailing/removeFilter', {mailing_id: this.mailingId, query: {filter: 'query'}})
        await this.$store.dispatch('mailing/removeFilter', {mailing_id: this.mailingId, query: {filter: 'id'}})
        await this.sendToEvery();
      }
    },
    async onSendModeClick (val: boolean) {
      try {
        this.forAllStitching = true
        this.sendEvery = val
        await this.onSendEveryChange(val)
        this.forAllStitching = false
      } catch (error) {
        console.error('LOG: onSendModeClick -> error', error)
        this.forAllStitching = false
      }
    }
  },
  watch: {
    checkedStuds (newVal, oldVal) {
      let diff = newVal.length - oldVal.length
      if (diff === 0) return false;
      let message = ''
      let type = 'error'
      if (diff < -1) {
        message = `${this.$t('labels.deleted')} ${Math.abs(diff)} ${this.$t('labels.users1')}`
      } else if (diff === -1) {
        message = `${this.$t('labels.user')} ${this.$t('labels.deleted1')}`
      } else if (diff === 1) {
        message = `${this.$t('labels.user')} ${this.$t('labels.added1')}`
        type = 'success'
      } else {
        message = `${this.$t('labels.added')} ${diff} ${this.$t('labels.users1')}`
        type = 'success'
      }
      this.$notify({
        // @ts-ignore
        title: this.$t('labels.success'),
        message,
        // @ts-ignore
        type
      });
    },
    sendEvery (newVal) {
      // this.onSendEveryChange(newVal)
    }
  }
})
